import React from 'react';
import Icon from '../../../components/AppIcon';

const AssessmentMetrics = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Total Assessments',
      value: metrics?.totalAssessments,
      icon: 'FileText',
      color: 'blue',
      bgColor: 'bg-blue-500/10',
      textColor: 'text-blue-500'
    },
    {
      label: 'Active Assessments',
      value: metrics?.activeAssessments,
      icon: 'Activity',
      color: 'purple',
      bgColor: 'bg-purple-500/10',
      textColor: 'text-purple-500'
    },
    {
      label: 'Completed Today',
      value: metrics?.completedToday,
      icon: 'CheckCircle',
      color: 'green',
      bgColor: 'bg-green-500/10',
      textColor: 'text-green-500'
    },
    {
      label: 'Average Score',
      value: `${metrics?.averageScore}%`,
      icon: 'TrendingUp',
      color: 'orange',
      bgColor: 'bg-orange-500/10',
      textColor: 'text-orange-500'
    },
    {
      label: 'Pass Rate',
      value: `${metrics?.passRate}%`,
      icon: 'Target',
      color: 'emerald',
      bgColor: 'bg-emerald-500/10',
      textColor: 'text-emerald-500'
    },
    {
      label: 'Pending Grading',
      value: metrics?.pendingGrading,
      icon: 'Clock',
      color: 'amber',
      bgColor: 'bg-amber-500/10',
      textColor: 'text-amber-500'
    },
    {
      label: 'Certifications Issued',
      value: metrics?.certificationsIssued,
      icon: 'Award',
      color: 'cyan',
      bgColor: 'bg-cyan-500/10',
      textColor: 'text-cyan-500'
    },
    {
      label: 'Remedials Scheduled',
      value: metrics?.remedialsScheduled,
      icon: 'AlertCircle',
      color: 'red',
      bgColor: 'bg-red-500/10',
      textColor: 'text-red-500'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metricCards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-12 h-12 rounded-lg ${card?.bgColor} flex items-center justify-center`}>
              <Icon name={card?.icon} size={24} className={card?.textColor} />
            </div>
          </div>
          <div className="text-2xl font-bold text-foreground mb-1">{card?.value}</div>
          <div className="text-sm text-muted-foreground">{card?.label}</div>
        </div>
      ))}
    </div>
  );
};

export default AssessmentMetrics;